export const DBConfig = {
  name: 'BSDrafting',
  version: 1,
  objectStoresMeta: [
    {
      store: 'draftList',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'data', keypath: 'data', options: { unique: true } },
        {
          name: 'dateCreation',
          keypath: 'dateCreation',
          options: { unique: false },
        },
      ],
    },
    {
      store: 'draftLogs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'data', keypath: 'data', options: { unique: true } },
        { name: 'status', keypath: 'status', options: { unique: false } },
        {
          name: 'dateCreation',
          keypath: 'dateCreation',
          options: { unique: false },
        },
      ],
    },
  ],
};
